import { createRoutine } from "../utils/routine.utils";
export var getGetPagedAction = function (params) {
    var entityName = params.entityName;
    return createRoutine("".concat(entityName, "S_GET_PAGED").toUpperCase());
};
